module.exports = __webpack_public_path__ + "img/Trading.61b6fb0b.svg";